import React from 'react';
import { useProducts } from '../../hooks/useProducts';

const GeneralDiscountBanner: React.FC = () => {
    const { discountSettings, isLoading } = useProducts();

    if (isLoading || !discountSettings.generalBanner?.isActive) {
        return null;
    }

    const { message, backgroundColor } = discountSettings.generalBanner;
    const bgColorClass = backgroundColor || 'bg-blue-600';

    return (
        <div className={`${bgColorClass} text-white text-center p-2 font-semibold text-sm animate-fadeIn`}>
            <i className="fas fa-tags mr-2"></i> {message}
        </div>
    );
};

export default GeneralDiscountBanner;